import React,{useEffect,useState} from 'react';
import {TableDatePicker} from '../function_lib/common_lib';
export function Comp_add_Marks(props){
 const [stSubjectIds,setSubjectIds]=useState("");
  useEffect(()=>{
    let strSubIds="";
    //alert(JSON.stringify(props.lsSubjects));
  for(let i=0;i<props.lsSubjects.length;i++){
     if(strSubIds!==""){
      strSubIds+=",";
     }
     strSubIds+=props.lsSubjects[i]["subject_master_id"];
     //alert(strSubIds);
  }
     setSubjectIds(strSubIds);
  },[props.lsSubjects])
  //alert(JSON.stringify(props.paymentBreakdown));
    return(<div className="modal fade bd-example-modal-xl"  id="divAddMarks" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl111" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Enter Marks</h5>
          <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        <form id="frmAddMarks" name="frmAddMarks">
        <input type="hidden" name="res_func" id="res_func" value="oldDues_okSucc" />
                <input type="hidden" name="curl_type" id="curl_type" value="insertResult" />
                <input type="hidden" name="m_type" id="m_type" value="insertResult" />
                <input type="hidden" name="pod_stu_admis_id" id="pod_stu_admis_id" value={props.studentId}/>
                <input type="hidden" name="pod_acc_inf_id" id="pod_acc_inf_id" value={props.app_user_id}/>
                <input type="hidden" name="subject_ids" id="subject_ids" value={btoa(stSubjectIds)}/>
        <div className="modal-body">
        <div className="row">
            <div className="col-md-12">
                <table class="table table-bordered table-sm">
                    <tr>
                    <td>Subject</td>
                    <td>Outstanding Marks</td>
                    <td>Marks Obtain</td>
                    <td>Practical</td>
                      </tr>
                  {props.lsSubjects.map((item,index)=>{
                    return <tr>
                        <td>{item["subject_nm"]}
                           
                            <input type="hidden" name={"popmarks_hid_outsmarks-"+item["subject_master_id"]} id={"popmarks_hid_outsmarks-"+item["subject_master_id"]}
                            value={item["total_marks"]}
                            />

<input type="hidden" name={"popmarks_hid_part_one_total-"+item["subject_master_id"]} id={"popmarks_hid_part_one_total-"+item["subject_master_id"]}
                            value={item["part_one_total"]}
                            />

<input type="hidden" name={"popmarks_hid_part_two_total-"+item["subject_master_id"]} id={"popmarks_hid_part_two_total-"+item["subject_master_id"]}
                            value={item["part_two_total"]}
                            />
                            
                        </td>
                        <td>{item["academic_part"]==="Academic"?item["total_marks"]:''}</td>
                        <td>
                            {item["academic_part"]==="Academic"?<input class="form-control required" type="number" name={"popmarks_obtain-"+item["subject_master_id"]} id={"popmarks_obtain-"+item["subject_master_id"]} />:
                            <select id={"popmarks_obtain-"+item["subject_master_id"]} name={"popmarks_obtain-"+item["subject_master_id"]} class="form-control required">
                                <option value={"0"}>-Select-</option>
                                <option value={"A"}>A</option>
                                <option value={"B"}>B</option>
                                <option value={"C"}>C</option>
                                <option value={"NA"}>NA(Not Applicable)</option>
                            </select>
                            }
                            
                            
                            </td>
                            {item["part_two_total"].toString()!=="0"?<td>
                            <input class="form-control required" type="number" name={"popmarks_obtain_pract-"+item["subject_master_id"]} id={"popmarks_obtain_pract-"+item["subject_master_id"]} />
                            </td>:<td></td>
                            }
                    </tr>
                  })}
                
                </table>

            </div>
                  {/* <!-- left column --> */}
                  <div className="col-md-12">
                      <div className="card card-danger">
                             
                              <div className="card-body">
                                  <div className="row">
                                  <div className="col-md-12">
                                    {/* other results input main */}
                                    <table class="table table-bordered table-sm">
                                      <tr>
                                        <td>Pass/Fail</td>
                                        <td><select  id="pass_fail" name="pass_fail" className='form-control required'>
                                          <option value={"0"}>-select-</option>
                                          <option value={"Pass"}>Pass</option>
                                          <option value={"Fail"}>Fail</option>
                                          <option value={"Passed by Grace and Promoted to Next Class"}>Passed by Grace and Promoted to Next Class</option>
                                          <option value={"Passed and Promoted to Next Class"}>Passed and Promoted to Next Class</option>
                                          </select></td>
                                      </tr>
                                      <tr>
                                        <td>Remark</td>
                                        <td><select id="remark" name="remark" className='form-control required'>
                                          <option value={"0"}>-select-</option>
                                          <option value={"Excellent"}>Excellent</option>
                                          <option value={"Good"}>Good</option>
                                          <option value={"Outstanding"}>Outstanding</option>
                                          <option value={"Brilliant"}>Brilliant</option>
                                          <option value={"Marvellous"}>Marvellous</option>
                                          <option value={"Bravo!"}>Bravo!</option>
                                          <option value={"Very Good"}>Very Good</option>
                                          <option value={"Keep It Up!"}>Keep It Up!</option>
                                          <option value={"Good Going"}>Good Going</option>
                                          <option value={"Good One"}>Good One</option>
                                          <option value={"Well Done"}>Well Done</option>
                                          <option value={"Nice Work"} >Nice Work</option>
                                          <option value={"Very Nice"} >Very Nice</option>
                                          <option value={"Be Regular"}>Be Regular</option>
                                          <option value={"Be Punctual"}>Be Punctual</option>
                                          <option value={"Be Attentive"}>Be Attentive</option>
                                          <option value={"Average"}>Average</option>
                                          <option value={"Good Improvement"}>Good Improvement</option>
                                          <option value={"Satisfactory"}>Satisfactory</option>
                                          <option value={"Work Hard"}>Work Hard</option>
                                          <option value={"Do Better Next Time"}>Do Better Next Time</option>
                                          <option value={"Do Much Better"}>Do Much Better</option>
                                          <option value={"Need To Improve"}>Need To Improve</option>
                                          </select></td>
                                      </tr>
                                      <tr>
                                        <td>Rank</td>
                                        <td><input class="form-control required" type='text' id="stu_rank" name="stu_rank" /></td>
                                      </tr>
                                      <tr>
                                        <td>Attendance Days(total)</td>
                                        <td><input class="form-control required" type='number' id="attend_total" name="attend_total" /></td>
                                      </tr>
                                      <tr>
                                        <td>Attendance Days(Present)</td>
                                        <td><input class="form-control required" type='number' id="attend_present" name="attend_present" /></td>
                                      </tr>

                                    </table>
                                    {/* end of other input main */}
                                    </div>
                                  </div>
                                
                                  <div className="col-md-6 respSSL"></div>
                                  <div id="testing2dd2222"></div>
                              </div>
                          
                      </div>
                  </div>
              </div>
        </div>
        <div className="modal-footer">
        <div id="getReponse" style={{color:"red"}}></div>
          <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" onClick={()=>props.saveMarks("frmAddMarks")} className="btn _btnSetColor121213 btn-primary">Submit</button>
        </div>
        </form>
      </div>
      </div>
      </div>)
}
export default Comp_add_Marks;